import { useEffect, useState } from 'react';
import BuildIcon from '@material-ui/icons/Build';
import { SidebarItem } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

const DEVOPS_GROUP_REF = 'group:default/devops-team';

// Shown to DevOps team members only. This only hides the link; the backend
// permission policy (packages/backend/src/permissionPolicy.ts) is what keeps
// the DevOps docs from everyone else.
export const DevOpsSidebarItem = () => {
  const identityApi = useApi(identityApiRef);
  const [isDevOps, setIsDevOps] = useState(false);

  useEffect(() => {
    identityApi
      .getBackstageIdentity()
      .then(identity =>
        setIsDevOps(identity.ownershipEntityRefs.includes(DEVOPS_GROUP_REF)),
      )
      .catch(() => setIsDevOps(false));
  }, [identityApi]);

  if (!isDevOps) {
    return null;
  }
  return (
    <SidebarItem
      icon={BuildIcon}
      to="/docs/default/component/devops-docs"
      text="DevOps"
    />
  );
};
